import {
  AccountBalance,
  Category,
  Info,
  LiveHelp,
  Menu,
  MiscellaneousServices,
  PsychologyAltSharp,
  Recommend,
  RequestQuote,
  School,
  ShoppingBag,
  ShoppingBagOutlined,
  ShoppingCart,
} from "@mui/icons-material";
import GavelIcon from "@mui/icons-material/Gavel";
import InfoIcon from "@mui/icons-material/Info";
import PhoneLockedIcon from "@mui/icons-material/PhoneLocked";
import {
  Badge,
  Button,
  IconButton,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { FC, Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import AnimateButton from "../../../components/@extended/AnimateButton";
import MouseOverPopover from "../../../components/MouseOverPopOver/MouseOverPopOver";
import MouseOverPopOverMobile2 from "../../../components/MouseOverPopOverMobile2/MouseOverPopOverMobile2";
import {
  CUSTOMER,
  DIAMOND,
  GOLD,
  PLATINUM,
  SILVER,
} from "../../../config/constants";
import {
  userIsAuthenticated,
  userIsAWorker,
} from "../../../stateManagement/helpers";
import {
  IAuthState,
  IUser,
  tryLogout,
} from "../../../stateManagement/reducers/authReducer";
import { ICartState } from "../../../stateManagement/reducers/cartReducer";
import {
  IMenuState,
  setGlobalNavItems,
  setMainNavItem,
} from "../../../stateManagement/reducers/menuReducer";
import { IOrdersState } from "../../../stateManagement/reducers/ordersReducer";
import { IRoutesState } from "../../../stateManagement/reducers/routesReducer";
import { IRootReducerT } from "../../../stateManagement/reduxStore";
import navItems, {
  diamondNavItems,
  goldNavItems,
  platnumNavItems,
  silverNavItems,
} from "./navItems";
import Profile from "./Profile";

function getNavIcon(navTitle: string, selected = false) {
  switch (navTitle) {
    case "Home":
      return (
        <AccountBalance color={selected ? "info" : ("white" as "primary")} />
      );
    case "About Us":
      return <Info color={selected ? "info" : ("white" as "primary")} />;
    case "Testimonials":
      return <Recommend color={selected ? "info" : ("white" as "primary")} />;
    case "Services":
      return (
        <MiscellaneousServices
          color={selected ? "info" : ("white" as "primary")}
        />
      );
    case "Memberships":
      return (
        <RequestQuote color={selected ? "info" : ("white" as "primary")} />
      );
    case "RESOURCE HUB":
    case "Resources":
      return <Category color={selected ? "info" : ("white" as "primary")} />;
    case "FAQ":
      return <LiveHelp color={selected ? "info" : ("white" as "primary")} />;
    case "Practice Areas":
      return <GavelIcon color={selected ? "info" : ("white" as "primary")} />;
    case "About":
      return <InfoIcon color={selected ? "info" : ("white" as "primary")} />;
    case "Contact":
      return <PhoneLockedIcon />;
    case "LMS":
      return <School color={selected ? "info" : ("white" as "primary")} />;
    case "HELP":
      return (
        <PsychologyAltSharp
          color={selected ? "info" : ("white" as "primary")}
        />
      );
    default:
      return null;
  }
}

interface IMobileNavProps2 {
  setPresentPage: (page: string) => void;
}

const MobileNavigation2: FC<IMobileNavProps2> = ({ setPresentPage }) => {
  const location = useLocation();

  const [pathname, setPathname] = useState(location.pathname);

  const { user, authToken } = useSelector<IRootReducerT, IAuthState>(
    (state) => state.auth,
  );
  const { globalNavItems } = useSelector<IRootReducerT, IMenuState>(
    (state) => state.menu,
  );

  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const theme = useTheme();
  const idGreaterThanMd = useMediaQuery(theme.breakpoints.up("md"));

  const title = process.env.REACT_APP_APP_NAME;

  const k = 1;
  // const drawerWidth = 240;
  const drawerWidth = "100%";

  const [mobileOpen, setMobileOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const [lNavItems, setLNavItems] = useState(
    globalNavItems.length > 0 ? globalNavItems : navItems,
  );

  const updateNavItems = () => {
    if (
      user &&
      userIsAuthenticated(user as IUser) &&
      user?.role?.name === CUSTOMER
    ) {
      const membershipType = SILVER;

      switch (membershipType) {
        case SILVER:
        default:
          setLNavItems(silverNavItems);
          dispatch(setGlobalNavItems(silverNavItems));
          break;
      }
    } else {
      setLNavItems(navItems);
    }
  };

  useEffect(() => {
    setPathname(location?.pathname);
  }, [location]);

  useEffect(() => {
    updateNavItems();
  }, [user, authToken]);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const drawer = (
    <div className="text-center ">
      <ul className="h-full">
        {lNavItems.map((page, index) => (
          <li key={`${index}${k}`} className="p-0">
            <div
              className="flex flex-row items-center justify-center w-full mx-auto"
              style={{
                color: pathname === page.url ? "rgba(26, 189, 84, 1)" : "black",
              }}
            >
              <MouseOverPopOverMobile2
                baseUri={page.id}
                url={page.url}
                title={page.title}
                navItems={page.children}
                callback={() => {
                  setMobileOpen(false);
                  dispatch(setMainNavItem(page));
                }}
              />
            </div>
          </li>
        ))}
      </ul>
    </div>
  );

  return (
    <>
      {!idGreaterThanMd && user && userIsAuthenticated(user as IUser) && (
        <Profile />
      )}
      <div className="flex justify-center mr-0  md:hidden lg:hidden">
        <button
          className="!text-black bg-transparent"
          onClick={handleDrawerToggle}
          aria-label="open drawer"
        >
          <Menu fontSize="medium" style={{ color: "#2F5042" }} />
        </button>
      </div>
      <nav>
        {mobileOpen && (
          <div
            className="fixed inset-0  z-50"
            onClick={handleDrawerToggle}
          ></div>
        )}
        <div
          className={`fixed top-[3.5rem] right-0 h-full w-full bg-white  transform ${
            mobileOpen ? "translate-x-0" : "translate-x-full"
          } transition-transform duration-300  ease-in-out z-[100000000] overflow-y-auto pt-6 pb-20 pl-2.5 md:block lg:hidden`}
        >
          {drawer}
          <div className="flex flex-col items-center w-full px-28 pt-4 text-xs space-y-4">
            {(!user || (user && !userIsAuthenticated(user as IUser))) && (
              <>
                <AnimateButton>
                  <Button
                    variant="contained"
                    size="large"
                    sx={{
                      mt: "1rem",
                      backgroundColor: "primary.main",
                      border: "solid black 1px",
                      boxShadow: theme.shadows[5],
                      px: "2rem !important",
                      color: "white",
                      "&:hover": {
                        borderColor: "primary.focus",
                        border: "solid white 1px",
                      },
                    }}
                    onClick={() => navigate("/login", { replace: true })}
                  >
                    <b>LOGIN</b>
                  </Button>
                </AnimateButton>
                <AnimateButton>
                  <Button
                    variant="contained"
                    size="large"
                    sx={{
                      backgroundColor: "primary.main",
                      border: "solid black 1px",
                      boxShadow: theme.shadows[5],
                      px: "2rem !important",
                      color: "white",
                      "&:hover": {
                        borderColor: "primary.focus",
                        border: "solid white 1px",
                      },
                    }}
                    onClick={() => navigate("/sign-up", { replace: true })}
                  >
                    <b>SIGN UP</b>
                  </Button>
                </AnimateButton>
              </>
            )}
            {user && userIsAuthenticated(user as IUser) && (
              <>
                <AnimateButton>
                  <Button
                    variant="contained"
                    size="large"
                    sx={{
                      backgroundColor: "primary.main",
                      border: "solid black 1px",
                      my: 2,
                      boxShadow: theme.shadows[5],
                      px: "2rem !important",
                      color: "white",
                      "&:hover": {
                        borderColor: "primary.focus",
                        border: "solid white 1px",
                      },
                    }}
                    onClick={() => {
                      dispatch(tryLogout({ authToken: authToken ?? "" }));
                    }}
                  >
                    <b>LOG OUT</b>
                  </Button>
                </AnimateButton>
              </>
            )}
          </div>
        </div>
      </nav>
    </>
  );
};

interface INavProps {
  setShowCartModal: (truth: boolean) => void;
}

const Nav = ({ setShowCartModal }: INavProps) => {
  const dispatch = useDispatch<any>();

  const { presentRoute } = useSelector<IRootReducerT, IRoutesState>(
    (state) => state.routes,
  );
  const { user, authToken } = useSelector<IRootReducerT, IAuthState>(
    (state) => state.auth,
  );
  const { activeMembership } = useSelector<IRootReducerT, IOrdersState>(
    (state) => state.orders,
  );
  const { globalNavItems } = useSelector<IRootReducerT, IMenuState>(
    (state) => state.menu,
  );
  const location = useLocation();
  const [presentPage, setPresentPage] = useState("");
  const navigate = useNavigate();

  const theme = useTheme();
  const idGreaterThanMd = useMediaQuery(theme.breakpoints.up("md"));

  const [isInitRender, setIsInitRender] = useState(true);
  useEffect(() => {
    if (isInitRender) {
      setPresentPage(location.pathname);
      setIsInitRender(false);
      return;
    }

    if (presentPage !== "") {
      setPresentPage(presentRoute);
    }
  }, [presentPage]);

  const [lNavItems, setLNavItems] = useState(
    globalNavItems.length > 0 ? globalNavItems : navItems,
  );

  const { cart } = useSelector<IRootReducerT, ICartState>(
    (state) => state.cart,
  );

  const updateNavItems = () => {
    if (
      user &&
      userIsAuthenticated(user as IUser) &&
      user?.role?.name === CUSTOMER
    ) {
      const membershipType = activeMembership?.rentalPackage?.rentalItems
        ? (activeMembership?.rentalPackage?.rentalItems)[0].name
        : "";

      switch (membershipType) {
        case DIAMOND:
          setLNavItems(diamondNavItems);
          dispatch(setGlobalNavItems(diamondNavItems));
          break;
        case PLATINUM:
          setLNavItems(platnumNavItems);
          dispatch(setGlobalNavItems(platnumNavItems));
          break;
        case GOLD:
          setLNavItems(goldNavItems);
          dispatch(setGlobalNavItems(goldNavItems));
          break;
        case SILVER:
        default:
          setLNavItems(silverNavItems);
          dispatch(setGlobalNavItems(silverNavItems));
          break;
      }
    } else {
      setLNavItems(navItems);
    }
  };

  useEffect(() => {
    updateNavItems();
  }, [user, authToken]);

  return (
    <>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent={idGreaterThanMd ? "space-between" : "flex-end"}
        id="demo-customized-button"
        sx={{
          width: { xs: "fit-content", md: "100%" },
          marginLeft: "auto !important",
          marginRight: "auto !important",
          display: { xs: "flex", md: "flex", lg: "flex" },
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="center"
          sx={{
            flex: "1",
          }}
        >
          <Stack
            direction="row"
            alignItems="center"
            id="demo-customized-button"
            spacing={0}
            sx={{
              width: "fit-content",
              display: { xs: "none", md: "none", lg: "flex" },
            }}
          >
            {lNavItems.map((page, index) => {
              return (
                <Fragment key={index}>
                  <MouseOverPopover
                    baseUri={page.id}
                    url={page.url}
                    title={page.title}
                    navItems={page.children}
                    callback={() => {
                      dispatch(setMainNavItem(page));
                    }}
                    isLast={index === lNavItems.length - 1}
                  />
                </Fragment>
              );
            })}
          </Stack>
        </Stack>
        <Stack
          direction="row"
          alignItems="center"
          id="demo-customized-button"
          spacing={4}
          sx={{
            width: "fit-content",
            height: "fit-content !important",
          }}
        >
          {user &&
            userIsAuthenticated(user as IUser) &&
            user.role?.name === CUSTOMER && (
              <AnimateButton>
                <IconButton
                  onClick={() => setShowCartModal(true)}
                  sx={{ "&:focus": { outline: "none !important" } }}
                >
                  <Badge
                    overlap="circular"
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    badgeContent={cart.items.length}
                    color="error"
                  >
                    <ShoppingBagOutlined
                      sx={{
                        color: "#2F5042",
                        height: "3rem",
                        width: "3rem",
                        fontSize: "1rem !important",
                        stroke: "#ffffff",
                        strokeWidth: "1",
                      }}
                    />
                  </Badge>
                </IconButton>
              </AnimateButton>
            )}
          {user &&
            userIsAuthenticated(user as IUser) &&
            userIsAWorker(user) && (
              <Stack
                direction="row"
                spacing="2rem"
                sx={{
                  height: "fit-content",
                  display: { xs: "none", md: "flex" },
                }}
              >
                <AnimateButton>
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "rgba(26, 189, 84, 1)",
                      my: 2,
                      color: "white",
                      width: "fit-content !important",
                      fontSize: { xs: ".75rem", md: ".85rem", lg: "1rem" },
                      height: "fit-content !important",
                      py: {
                        xs: ".5rem !important",
                        md: ".75rem !important",
                        lg: "1.5rem",
                      },
                      px: {
                        xs: ".75rem !important",
                        md: "1.5rem !important",
                        lg: "2rem",
                      },
                    }}
                    onClick={() => {
                      navigate("/dashboard", { replace: true });
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: { xs: ".75rem", md: ".85rem", lg: "1rem" },
                        maxWidth: "7rem !important",
                      }}
                    >
                      <b>{user?.role?.name?.toUpperCase()} DASHBOARD</b>
                    </Typography>
                  </Button>
                </AnimateButton>
              </Stack>
            )}
          {(!user || (user && !userIsAuthenticated(user as IUser))) &&
            idGreaterThanMd && (
              <Stack
                direction="row"
                spacing="2rem"
                alignItems="center"
                sx={{
                  marginLeft: "0 !important",
                }}
              >
                <AnimateButton>
                  <Button
                    variant="outlined"
                    sx={{
                      my: 2,
                      color: "#2F5042 !important",
                      border: "1px solid #2F5042 !important",
                      py: {
                        xs: ".5rem !important",
                        md: ".75rem !important",
                        lg: "1.5rem",
                      },
                      px: {
                        xs: ".75rem !important",
                        md: "1.5rem !important",
                        lg: "2rem",
                      },
                      "&:hover": {
                        color: "white !important",
                        backgroundColor: "#2F5042 !important",
                      },
                    }}
                    onClick={() => {
                      navigate("/login", { replace: true });
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: { xs: ".65rem", md: ".75rem", lg: ".8rem" },
                        fontFamily: "Inter",
                      }}
                    >
                      LOGIN
                    </Typography>
                  </Button>
                </AnimateButton>
                <AnimateButton>
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "#C8A96A",
                      my: 2,
                      color: "white",
                      py: {
                        xs: ".5rem !important",
                        md: ".75rem !important",
                        lg: "1.5rem",
                      },
                      px: {
                        xs: ".75rem !important",
                        md: "1.5rem !important",
                        lg: "2rem",
                      },
                    }}
                    onClick={() => {
                      navigate("/sign-up", { replace: true });
                    }}
                  >
                    <Typography
                      noWrap
                      variant="body1"
                      sx={{
                        fontSize: { xs: ".65rem", md: ".75rem", lg: ".8rem" },
                        fontFamily: "Inter",
                      }}
                    >
                      SIGN UP
                    </Typography>
                  </Button>
                </AnimateButton>
              </Stack>
            )}
          {user && userIsAuthenticated(user as IUser) && idGreaterThanMd && (
            <Profile />
          )}
        </Stack>
        {!idGreaterThanMd && (
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-around"
            spacing={1}
            sx={{
              width: "fit-content",
              p: "0",
            }}
          >
            <MobileNavigation2 setPresentPage={setPresentPage} />
          </Stack>
        )}
      </Stack>
    </>
  );
};

export default Nav;
